import { useQuery } from '@apollo/client';
import { GET_DOCUMENT_TYPES } from '../../graphql/queries';

export interface DocumentTypeRecord {
  uuid: string;
  name: string;
  description: string;
}

interface GetDocumentTypesResponse {
  getAllDocumentTypes: DocumentTypeRecord[];
}

export const useGetDocumentTypes = (): {
  documentTypes?: DocumentTypeRecord[];
  loading: boolean;
  error?: any;
} => {
  const { data, loading, error } = useQuery<GetDocumentTypesResponse>(GET_DOCUMENT_TYPES);

  return {
    documentTypes: data?.getAllDocumentTypes,
    loading,
    error,
  };
};
